<template>
  <section>
    <!-- Header -->
    <div class="header-bar header-fixed header-app header-bar-detached">
      <a data-bs-toggle="offcanvas" data-bs-target="#menu-main" href="#"
        ><i class="bi bi-list color-theme"></i
      ></a>
      <!-- <a href="#" class="header-title color-theme">SAMU IT4D</a> -->
      <div class="logo-container">
        <img
          src="../../assets/images/it4d-e-samu.png"
          alt="logo"
          height="22"
          class="logo"
        />
      </div>

      <!-- <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-color"
        ><i class="bi bi-palette-fill font-13 color-highlight"></i
      ></a> -->
      <!-- <a href="#" data-bs-toggle="offcanvas" data-bs-target="#menu-bell"
        ><em class="badge bg-highlight ms-1">3</em
        ><i class="font-14 bi bi-bell-fill"></i
      ></a> -->
      <!-- <a href="#" class="show-on-theme-light" @click="selectDarkMode"
        ><i class="bi bi-moon-fill font-13"></i
      ></a>
      <a href="#" class="show-on-theme-dark" @click="selectLightMode"
        ><i class="bi bi-lightbulb-fill color-yellow-dark font-13"></i
      ></a> -->
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      authenticated: false,
    };
  },
  props: ["menu"],
  computed: {},
  methods: {
    selectDarkMode() {
      $("body").removeClass("theme-light").addClass("theme-dark");
    },
    selectLightMode() {
      $("body").removeClass("theme-dark").addClass("theme-light");
    },
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      self.$http
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          document.location.reload(true);
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
  },
  mounted() {
    this.authenticated = this.$store.getters.authenticated;
    this.user = this.$store.getters.user;
  },
};
</script>


<style scoped>
.header-bar {
  display: flex;
  align-items: center;
}

.logo-container {
  text-align: center;
}

.logo {
  margin-top: 0.5rem !important;
  margin-bottom: 10px !important;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderNavbar.vue